// The filter vocabularies live in their own module, not next to the component
// that renders them: a file that exports both a component and a constant breaks
// Fast Refresh (react-refresh/only-export-components), and the module lints at
// --max-warnings 0.
//
// Keeping them separate also means the tests can assert the option lists without
// importing a component.

export interface ZonesFilterFormValues {
    provider: string;
    delegation: string;
}

// ⚠️ THREE OPTIONS, NOT TWO.
//
// "Not determined" is a real, selectable state — `appearsDelegated` is null
// when no conclusion was reached, which is DIFFERENT from false. A two-option
// filter would make those zones unreachable through the UI while they still
// count against the footer: the null/false collapse the schema warns about,
// reintroduced at the filter instead of the badge.
export const DELEGATION_OPTIONS = [
    {
        value: 'DELEGATED',
        label: 'Delegated',
    },
    {
        value: 'NOT_DELEGATED',
        label: 'Not delegated',
    },
    {
        value: 'UNDETERMINED',
        label: 'Not determined',
    },
];

export const PROVIDER_OPTIONS = [
    {
        value: 'ROUTE53',
        label: 'Route 53',
    },
    {
        value: 'CLOUDFLARE',
        label: 'Cloudflare',
    },
    {
        value: 'FAKE',
        label: 'Fake (test)',
    },
];
